import { useEffect, useState } from "react";
import { API, adminApi } from "./AdminDashboard";

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
};

const Section = ({ title, testId, children }) => (
  <div className="rounded-2xl border border-[#E2E8E4] bg-[#F2F4F0] p-7" data-testid={testId}>
    <h3 className="font-display text-2xl text-[#1A2F24] mb-5">{title}</h3>
    {children}
  </div>
);

const Empty = ({ text }) => <p className="text-sm text-[#5C7368]">{text}</p>;

const ListsTab = () => {
  const [contacts, setContacts] = useState([]);
  const [volunteers, setVolunteers] = useState([]);
  const [donations, setDonations] = useState([]);

  useEffect(() => {
    adminApi().get(`${API}/admin/contacts`).then((r) => setContacts(r.data.items || [])).catch(() => {});
    adminApi().get(`${API}/admin/volunteers`).then((r) => setVolunteers(r.data.items || [])).catch(() => {});
    adminApi().get(`${API}/admin/donations`).then((r) => setDonations(r.data.items || [])).catch(() => {});
  }, []);

  return (
    <div className="space-y-8" data-testid="admin-inbox-tab">
      <Section title="Donations" testId="admin-donations-list">
        {donations.length === 0 ? <Empty text="No donations yet." /> : (
          <div className="space-y-3">
            {donations.map((d) => (
              <div key={d.session_id} className="rounded-xl bg-white/60 border border-[#E2E8E4] px-5 py-3.5 flex flex-wrap items-center justify-between gap-3" data-testid={`admin-donation-${d.session_id.slice(-6)}`}>
                <p className="font-display text-xl text-[#1A2F24]">${d.amount?.toLocaleString()} <span className="text-xs font-body uppercase text-[#5C7368]">{d.currency}</span></p>
                <span className={`rounded-full px-3 py-1 text-[10px] tracking-[0.15em] uppercase ${d.payment_status === "paid" ? "bg-[#C4D7D1] text-[#1E352A]" : "bg-[#E2E8E4] text-[#5C7368]"}`}>{d.payment_status}</span>
                <p className="text-xs text-[#5C7368]">{fmtDate(d.created_at)}</p>
              </div>
            ))}
          </div>
        )}
      </Section>

      <Section title="Volunteer Sign-Ups" testId="admin-volunteers-list">
        {volunteers.length === 0 ? <Empty text="No volunteer sign-ups yet." /> : (
          <div className="space-y-3">
            {volunteers.map((v, i) => (
              <div key={v.id || i} className="rounded-xl bg-white/60 border border-[#E2E8E4] px-5 py-4" data-testid={`admin-volunteer-${i}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <p className="font-semibold text-sm text-[#1A2F24]">{v.name}</p>
                  <p className="text-xs text-[#5C7368]">{v.email}{v.phone ? ` · ${v.phone}` : ""}</p>
                </div>
                {v.interests?.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {v.interests.map((t) => <span key={t} className="rounded-full bg-[#C4D7D1] px-2.5 py-0.5 text-[10px] uppercase tracking-wide text-[#1E352A]">{t}</span>)}
                  </div>
                )}
                {v.message && <p className="mt-2 text-sm text-[#5C7368]">{v.message}</p>}
              </div>
            ))}
          </div>
        )}
      </Section>

      <Section title="Contact Messages" testId="admin-contacts-list">
        {contacts.length === 0 ? <Empty text="No messages yet." /> : (
          <div className="space-y-3">
            {contacts.map((c, i) => (
              <div key={c.id || i} className="rounded-xl bg-white/60 border border-[#E2E8E4] px-5 py-4" data-testid={`admin-contact-${i}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <p className="font-semibold text-sm text-[#1A2F24]">{c.name}</p>
                  <p className="text-xs text-[#5C7368]">{c.email} · {fmtDate(c.created_at)}</p>
                </div>
                <p className="mt-2 text-sm text-[#5C7368]">{c.message}</p>
              </div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
};

export default ListsTab;
